import ArticleGroup from './ArticleGroup'
(function(){
    const $articleGroup = document.querySelectorAll('.article-group')
    $articleGroup.forEach(($a) => new ArticleGroup($a))
})()